import { AuthProvider } from '@/context/AuthContext'
import { useLogout } from 'BrokerTsLib/src/hooks/useAccount'
import { setInterceptorLogoutCallback } from 'BrokerTsLib/src/Utils/apiClient'
import { Outlet } from 'react-router-dom'

export const AuthLayout = () => {
  const { logout, isLoggingOut } = useLogout()

  setInterceptorLogoutCallback(() => {
    if (!isLoggingOut) {
      logout()
    }
  })

  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  )
}
